import { END_POINTS } from "../helpers";
import { AddressRes, CommonBody } from "../types/General";

import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const manageAddressApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAddress: builder.query<
      CommonResponseType & { data: { address: AddressRes[] } },
      {}
    >({
      query: () => ({
        url: END_POINTS.getMyAddress,
        method: "GET",
      }),
    }),
    addAddress: builder.mutation<
      CommonResponseType & { data: AddressRes },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addAddress,
        method: "POST",
        body,
      }),
    }),
    getAddressById: builder.query<
      CommonResponseType & { data: AddressRes },
      { address_id: string }
    >({
      query: ({ address_id }) => ({
        url: `${END_POINTS.getMyAddress}/${address_id}`,
        method: "GET",
      }),
    }),

    updateAddress: builder.mutation<
      CommonResponseType & { data: AddressRes },
      { address_id: string; encryptedBody: CommonBody }
    >({
      query: ({ encryptedBody, address_id }) => ({
        url: `${END_POINTS.updateAddress}/${address_id}`,
        method: "PUT",
        body: encryptedBody,
      }),
    }),

    deleteAddressById: builder.mutation<
      CommonResponseType & { data: AddressRes },
      { address_id: string }
    >({
      query: ({ address_id }) => ({
        url: `${END_POINTS.deleteAddress}/${address_id}`,
        method: "DELETE",
      }),
    }),
    postSelectAddress: builder.mutation<
      CommonResponseType & { data: AddressRes },
      { id: string; isDefault?: boolean }
    >({
      query: ({ id, isDefault }) => ({
        url: `${END_POINTS.selectAddress}/${id}?default=${isDefault}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLazyGetAddressQuery,
  useAddAddressMutation,
  useDeleteAddressByIdMutation,
  useUpdateAddressMutation,
  useLazyGetAddressByIdQuery,
  usePostSelectAddressMutation,
} = manageAddressApi;
